@if (loggedUser && isMobileView && (pluginInjectorService.widgetService.widgets$ | async)?.length) {
  <swiper-container appSwiper #swiper [config]="swiperConfig" class="swiper-mobile-container" events-prefix="swiper-" init="false" (swiper-slidechange)="onSwiperSlideChange()">
      @for (widget of pluginInjectorService.widgetService.widgets$ | async; track widget._id; let widgetIndex = $index) {
      <swiper-slide
        (touchstart)="onWidgetHover(widget)"
                  [ngClass]="{
                   'widget-in-fullscreen': widgetInFullscreen
                   }"
        #widgetItems
        >
        @if (showWidgetHeader(widget)) {
          <div class="swiper-slide-mobile-header"
            [@hoverAnimation]="widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed || (widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed && widget.isHeaderHovered) ? 'visible' : 'hidden'"
           [ngClass]="{
            'always-displayed': widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed,
            'always-displayed-off': widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed && widgetInFullscreen && !widget.isHeaderHovered,
            'hover-displayed': widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed
            }"
            >
            @if (pluginInjectorService.widgetService.showWidgetTitle(widget)) {
              <span class="swiper-header-title ">{{ widget.name }}{{ widget.extraTitle }}</span>
            }
            <span></span>
            <span class="adx-button-group">
              <!-- toggle fullscreen mode -->
              @if (!(pluginInjectorService.widgetService.edit$ | async)) {
                <button mat-icon-button class="swiper-icon"
                  (click)="toggleFullscreen(widgetIndex)">
                  <fa-icon class="swiper-fa-icon" [icon]="widgetInFullscreen ? 'compress' : 'expand'"></fa-icon>
                </button>
              }
              <!-- open settings component -->
              @if (pluginInjectorService.widgetService.isConfigurable(widget) && widgetSettingsEnabled(widget)) {
                <button mat-icon-button class="swiper-icon"
                  (click)="pluginInjectorService.widgetService.loadSettingComponent(widget, modelService, pluginInjectorService, dialog)">
                  <fa-icon [icon]="'bars'" class="swiper-fa-icon"></fa-icon>
                </button>
              }
              <!-- remove widget -->
              @if (pluginInjectorService.widgetService.edit$ | async) {
                <button mat-icon-button class="swiper-icon"
                  (click)="removeWidgetItem($event, widget)">
                  <fa-icon class="swiper-fa-icon" [icon]="'xmark'"></fa-icon>
                </button>
              }
            </span>
          </div>
        }
        @if (showWidgetHeader(widget)) {
          <mat-divider></mat-divider>
        }
        <div class="swiper-item-content" [ngClass]="(widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed && widget.isHeaderHovered) ? 'swiper-item-header-on-hover' : ''">
          <!-- Render grid item content here -->
          <ng-template
            [appWidgetItem]="widget"
            [isHeaderHovered]="widgetHeaderIsHovered(widget)"></ng-template>
        </div>
      </swiper-slide>
    }
  </swiper-container>
}


@if (loggedUser && !isMobileView) {
  <gridster [options]="pluginInjectorService.widgetService.options" id="grid">
      @for (widget of pluginInjectorService.widgetService.widgets$ | async; track widget._id; let widgetIndex = $index) {
      <gridster-item
        [item]="widget"
        class="gridster-item"
        (mouseenter)="onWidgetHover(widget)"
        (mouseleave)="onWidgetHoverCancel(widget)"
        #widgetItems
                   [ngClass]="{
                   'widget-in-fullscreen': widgetInFullscreen
                   }">
        @if (showWidgetHeader(widget)) {
          <div class="adx-grid-item-header"
            [@hoverAnimation]="widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed || (widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed && widget.isHeaderHovered) ? 'visible' : 'hidden'"
           [ngClass]="{
            'always-displayed': widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed,
            'always-displayed-off': widget.appPluginWidget.settings.widgetHeader.alwaysDisplayed && widgetInFullscreen && !widget.isHeaderHovered,
            'hover-displayed': widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed
            }"
            >
            @if (pluginInjectorService.widgetService.showWidgetTitle(widget)) {
              <span class="adx-grid-item-header-title ">{{ widget.name }}{{ widget.extraTitle }}</span>
            }
            <span></span>
            <span class="adx-button-group">
              <!-- toggle fullscreen mode -->
              @if (!(pluginInjectorService.widgetService.edit$ | async)) {
                <button mat-icon-button class="adx-grid-item-header-icon" aria-label="Fullscreen-Button"
                  (click)="toggleFullscreen(widgetIndex)">
                  <fa-icon class="adx-grid-item-fa-icon" [icon]="widgetInFullscreen ? 'compress' : 'expand'"></fa-icon>
                </button>
              }
              <!-- open settings component -->
              @if (pluginInjectorService.widgetService.isConfigurable(widget) && widgetSettingsEnabled(widget)) {
                <button mat-icon-button class="adx-grid-item-header-icon" aria-label="Settings-Button"
                  (click)="pluginInjectorService.widgetService.loadSettingComponent(widget, modelService, pluginInjectorService, dialog)">
                  <fa-icon class="adx-grid-item-fa-icon" [icon]="'bars'"></fa-icon>
                </button>
              }
              <!-- remove widget -->
              @if (pluginInjectorService.widgetService.edit$ | async) {
                <button mat-icon-button class="adx-grid-item-header-icon" aria-label="Close-Button"
                  (mousedown)="removeWidgetItem($event, widget)"
                  (touchstart)="removeWidgetItem($event, widget)">
                  <fa-icon [icon]="'xmark'"></fa-icon>
                </button>
              }
            </span>
          </div>
        }
        @if (showWidgetHeader(widget)) {
          <mat-divider></mat-divider>
        }
        <div class="adx-grid-item-content" [ngClass]="widget.appPluginWidget.settings.widgetHeader.onHoverDisplayed && widget.isHeaderHovered ? 'widget-header-on-hover' : ''">
          <!-- Render grid item content here -->
          <ng-template
            [appWidgetItem]="widget"
            [isHeaderHovered]="widgetHeaderIsHovered(widget)"></ng-template>
        </div>
      </gridster-item>
    }
  </gridster>
}
